"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";

const comingSoonFromEnv = import.meta.env.VITE_COMING_SOON === "true";

type ComingSoonContextValue = {
  comingSoon: boolean;
};

const ComingSoonContext = createContext<ComingSoonContextValue>({
  comingSoon: comingSoonFromEnv,
});

export function ComingSoonProvider({ children }: { children: ReactNode }) {
  const value = useMemo(
    () => ({ comingSoon: comingSoonFromEnv }),
    []
  );
  return (
    <ComingSoonContext.Provider value={value}>
      {children}
    </ComingSoonContext.Provider>
  );
}

export function useComingSoon(): boolean {
  const ctx = useContext(ComingSoonContext);
  return ctx?.comingSoon ?? comingSoonFromEnv;
}
